// extracted by mini-css-extract-plugin
export default {"container":"TabItem_container__Ud37m"};